<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="col-12">
        <div class="card-body">
          <fiscal-juridico-solicitacoes
              :tps_tipo="1"
              :list_cnae="list_cnae"
              :list_servicos="list_atividades"
              :up_contador="contador">
          </fiscal-juridico-solicitacoes>
          <div class="row">
            <div class="col-6">
              <b-form-group class="mt-3 text-left">
                <button type="button"
                        @click="voltar"
                        title="Salvar dados da empresa"
                        class="btn btn-dark">
                  <i class="bx bx-arrow-back"></i> Voltar
                </button>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group class="mt-3 text-right">
                <button type="button"
                        @click="saveDadosFiscais"
                        title="Salvar dados da empresa"
                        class="btn btn-success">
                  <i class="bx bx-check-double"></i> Salvar dados fiscais
                </button>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import FiscalJuridicoSolicitacoes from "@/router/views/contribuinte/components/fiscal-juridico-solicitacoes"
import {getDadosFiscais, putDadosFiscais} from "@/api/admin/gestao/empresas";
const {notifySucesso, notifyErro} = require("../../../../../helps/notificacao");

export default {
  components: {
    Loader,
    Aguarde,
    FiscalJuridicoSolicitacoes
  },
  props: {
    eco_codigo: {
      type: Number,
      required: true
    },
  },
  computed: {
    temServico: {
      get: function () {
        return this.$store.state.solicitacao.cnaeTemServicos;
      },
    },
  },
  data() {
    return {
      showAguarde: false,
      httpSend: false,
      list_cnae: [],
      list_atividades: [],
      contador: {
        proprio_contador: '',
        pes_codigo: '',
        pes_cpfcnpj: '',
        pes_nome: '',
      }
    };
  },
  created() {
    this.getDados();
  },
  methods: {
    getDados() {
      this.httpSend = true;
      getDadosFiscais(this.eco_codigo).then(response => {
        if (response.status) {
          this.list_cnae = response.dados.cnaes;
          this.list_atividades = response.dados.atividades;
          if (response.dados.contador) {
            this.contador = response.dados.contador;
          }
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveDadosFiscais() {
      if (this.list_atividades.length < 1 && this.temServico) {
        notifyErro("DattaNFSe", "Necessário selecionar no mínimo uma atividade")
        return false
      }
      const dados = {eco_cnae: this.list_cnae, eco_atividades: this.list_atividades, contador: this.contador}
      this.httpSend = true;
      putDadosFiscais(this.eco_codigo, dados).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    voltar() {
      this.$router.back();
    }
  }
};
</script>

